import React, { useState } from "react";
import "./Dropdown.scss";
import { Button } from "components/atoms";
import { PiCaretDownBold } from "react-icons/pi";

interface DropdownProps {
  title: string;
  extraElement?: React.ReactNode;
  children: React.ReactNode;
}

const Dropdown: React.FC<DropdownProps> = ({
  title,
  extraElement,
  children,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleToggle = () => {
    setIsOpen((prev) => !prev);
  };

  return (
    <div className="dropdown-wrapper">
      <div className="dropdown-header">
        <div className="dropdown-title-container">
          {extraElement && <span>{extraElement}</span>}
          <span
            onClick={handleToggle}
            className={`dropdown-title ${isOpen ? "blue-title" : ""}`}
          >
            {title}
          </span>
        </div>
        <Button.Icon
          icon={
            <PiCaretDownBold
              className={`dropdown-close-button ${isOpen ? "is-open" : ""}`}
              onClick={handleToggle}
            />
          }
        />
      </div>
      <div className={`dropdown-content ${isOpen ? "is-open" : ""}`}>
        {children}
      </div>
    </div>
  );
};

export default Dropdown;
